import React from 'react';
import './MessageSection.css';

function MessageIcon({ icon }) {
  return (
    <div className="message-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={icon.viewBox}
        style={{ verticalAlign: 'middle' }}>
          {/* !Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
          <path 
            d={icon.svg_path}
            style={{
              fill: typeof icon.forceColor === 'boolean' && icon.forceColor ? 'currentColor' : (
                icon.fill === "true" ? (
                  icon.useHighlight === "true" ? 'var(--icon-color)' : 'var(--icon-color)'
                ) : 'none'
              ),
              stroke: icon.fill === "true" && icon.useHighlight === "true" 
                ? 'var(--highlight-color)' 
                : 'var(--icon-color)'
            }}
          />
      </svg>
    </div>
  );
}

export default MessageIcon; 